import React, { ReactNode } from "react";
import { useIsMobileView } from "@/contexts/ResponsiveProvider";
import { BlurBgOverlay } from "@/v2-components/pages/software/components/shared/blur-bg-overlay";
import Image from "next/image";

interface SoftwareMainImgSectionProps {
  bgImg: string;
  bgMobileImg: string;
  contents: ReactNode;
}
export const SoftwareMainImgSection = ({
  bgImg,
  bgMobileImg,
  contents,
}: SoftwareMainImgSectionProps) => {
  const isMobile = useIsMobileView();

  return (
    <section>
      <div className="relative h-[240px] w-full md:h-[554px]">
        <div className="absolute inset-0 flex">
          <figure className="mx-auto w-full xs:relative">
            <Image
              src={bgImg}
              width={1920}
              height={554}
              quality={80}
              alt={"software-title-img"}
              className={
                "hidden max-h-[554px] min-h-[554px] w-full object-cover md:block"
              }
              priority
            />
            <Image
              src={bgMobileImg}
              alt={"software-title-mobile-img"}
              className={"object-cover md:hidden"}
              fill
            />
          </figure>
        </div>
        {!isMobile && contents}
      </div>

      {isMobile && <BlurBgOverlay src={bgMobileImg}>{contents}</BlurBgOverlay>}
    </section>
  );
};
